import React from 'react';
import LocalizedStrings from 'react-localization';
import { connect } from 'react-redux';
import { localisedText } from '../../lib/localisation.es6';
import * as actions from '../../containers/BeneficiaryList/actions.js'
import ProductsHeader from '../../containers/NewProductList/components/ProductsHeader/ProductsHeader';
import AddBenefiary from './AddBenefiary';
import BeneficiaryTable from './BeneficiaryTable'
import AlertDialog from '../AlertDialog/index.es6.js';
import { Button } from '@mui/material';
import { TextValidator, SelectValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Typography from "@mui/material/Typography";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Grid from "@mui/material/Grid";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CircularProgress from '@mui/material/CircularProgress';
import { InputAdornment } from "@mui/material";
import MenuItem from '@mui/material/MenuItem';

import { PRIMARY_THEME_COLOR_SHADE_1 } from "../../lib/constants";
import {
  getInternationalCallingCode,
  getLocalNumberLength, getPartner,
  isSouthAfricanPartner,
  isVAlidSouthAfricanNationalId
} from "../../lib/access.es6";
import {formatDate} from "../../lib/utils.es6";
import {updateCurrentLanguage} from "../../lib/languageUtils.es6";
import {TextField} from "material-ui";
import {DatePicker} from "@material-ui/pickers";


export class Beneficiary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      labels: new LocalizedStrings(localisedText),
      openAddBeneficiaryDialog: false,
      beneficiaryGuid: null,
      openConfirmDelete: false,
      openEditModal:false,
      anchorElAction: null,
    }
    this.onFullNameChange = this.onFullNameChange.bind(this);
    this.onFirstNameChange = this.onFirstNameChange.bind(this);
    this.onLastNameChange = this.onLastNameChange.bind(this);
    this.onDateOfBirthChange = this.onDateOfBirthChange.bind(this);
    this.onNationalIdChange = this.onNationalIdChange.bind(this);
    this.onAddressChange = this.onAddressChange.bind(this);
    this.onEmailChange = this.onEmailChange.bind(this);
    this.onMsiSdnChange = this.onMsiSdnChange.bind(this);
    this.onGenderChange = this.onGenderChange.bind(this);
    this.deleteBeneficiary = this.deleteBeneficiary.bind(this);
    this.handleOpenConfirmDeleteDialog = this.handleOpenConfirmDeleteDialog.bind(this);
    this.updateBeneficiary = this.updateBeneficiary.bind(this);
    this.deleteBeneficiary = this.deleteBeneficiary.bind(this);
  }

  componentDidMount() {
    if (this.props.customerGuid) {
      this.props.dispatch(actions.getCustomerBeneficiaryRequest(this.props.customerGuid));
    }

    const partner = getPartner();
    const nationalIdRegex = partner ? partner.country.national_id_regex : '';
    const pattern = new RegExp(nationalIdRegex);
    
    ValidatorForm.addValidationRule('isValidNationalId', value => {
      if (!isSouthAfricanPartner()) {
        return pattern.test(value);
      }
      const result = isVAlidSouthAfricanNationalId(value);
      if (result.isValid) {
        this.setState({
          dateOfBirth: formatDate(new Date(result.dob)),
          gender: result.gender,
          SAIdCheckError: result.error,
        });
        return true;
      }
      this.setState({ SAIdCheckError: result.error });
      return false;
    });
  }

  componentWillUnmount() {
    ValidatorForm.removeValidationRule('isValidNationalId');
  }

  componentDidUpdate() {
    this.updateLanguage();
  }

  updateLanguage() {
    updateCurrentLanguage(
      this.props.globalData.language,
      'Customer',
      this.state.labels
    );
  }

  onFullNameChange = (event) =>{
    this.setState({ full_name: event.target.value });
  }
  onFirstNameChange =(event) =>{
    this.setState({ first_name: event.target.value });
  }
  onLastNameChange =(event) =>{
    this.setState({ last_name: event.target.value });
  }
  onDateOfBirthChange = (date) =>{
    if (date) {
      this.setState({ date_of_birth: formatDate(new Date(date)) });
    } else {
      this.setState({ date_of_birth: '' });
    }
  }
  onNationalIdChange = (event) =>{
    this.setState({ national_id: event.target.value });
  }
  onAddressChange = (event) =>{
    this.setState({ address: event.target.value });
  }
  onEmailChange = (event) =>{
    this.setState({ email: event.target.value });
  }
  onMsiSdnChange = (event) =>{
    this.setState({ msisdn: event.target.value });
  }
  onGenderChange  = (event) =>{
    this.setState({ gender: event.target.value });
  }
  closeAddBeneficiaryDialog = () => {
    this.setState({ openAddBeneficiaryDialog: false })
  }
  handleCloseActionMenu() {
    this.setState({ anchorElAction: null });
  }
  addBenefiary = (payload) => {
    console.log("add beneficiary payload", payload)
    this.props.dispatch(actions.addCustomerBeneficiaryRequest(payload));
  }

  toggleEditBeneficiaryDialog() {
    this.setState({ openEditModal: !this.state.openEditModal });
  }

  closeEditBeneficiaryDialog() {
    this.setState({ openEditModal: false });
  }
  openEditBeneficiaryDialog() {
    this.setState({ openEditModal: true });
  }
  setEditBeneficiary(beneficiary) {
    console.log("setting edit beneficiary", beneficiary)
    this.setState({
      beneficiaryGuid: beneficiary.guid,
      full_name: beneficiary.full_name,
      first_name: beneficiary.first_name,
      last_name: beneficiary.last_name,
      msisdn: beneficiary.msisdn,
      date_of_birth: beneficiary.date_of_birth,
      address: beneficiary.address,
      national_id: beneficiary.national_id,
      gender: beneficiary.gender,
      email: beneficiary.email,
    });

   this.toggleEditBeneficiaryDialog();
    this.handleCloseActionMenu();
  }
  updateBeneficiary = () =>{
    // console.log(this.state.full_name, this.state.first_name)
    if(!this.state.full_name || !this.state.first_name || !this.state.last_name || !this.state.msisdn || !this.state.date_of_birth || !this.state.national_id || !this.state.address || !this.state.gender || !this.state.email){
      return;
    }

    const payload = {
      guid: this.state.beneficiaryGuid,
      full_name: this.state.full_name ,
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      msisdn: this.state.msisdn,
      date_of_birth: this.state.date_of_birth,
      national_id: this.state.national_id,
      address: this.state.address,
      gender: this.state.gender,
      email:  this.state.email
    };
    this.props.onUpdate(payload);
    this.toggleEditBeneficiaryDialog();
  }

  setDeleteDialog(beneficiary) {
    this.setState({ openConfirmDelete: true, beneficiaryGuid: beneficiary.guid });
    this.handleCloseActionMenu();

  }
  handleOpenConfirmDeleteDialog(beneficiary) {
    this.setState({ openConfirmDelete: false, beneficiaryGuid: beneficiary.guid });
  }
  deleteBeneficiary() {
    this.props.onDelete(this.state.beneficiaryGuid);
    this.setState({ openConfirmDelete: false });
  }
  deleteBeneficiaryDialog() {
    const { labels, } = this.state;
    const btnStyle = {
      margin: '2%',
      green: {
        backgroundColor: 'orangered',
        color: 'white',
        margin: '2px',
        height: '50px',
        padding: '0 30px',
      },
      danger: {
        backgroundColor: 'green',
        color: 'white',
        margin: '2px',
        height: '50px',
        padding: '0 30px',
      },
    };

    const confirmDeleteActions = [
      <Button style={btnStyle.danger} onClick={this.handleOpenConfirmDeleteDialog}>
        {labels.no}
      </Button>,
      <Button style={btnStyle.green} onClick={this.deleteBeneficiary}>
        {labels.yes}
      </Button>,
    ];

    return (
      <Dialog
        open={this.state.openConfirmDelete}
        onClose={this.handleOpenConfirmDeleteDialog}
        aria-labelledby="form-dialog-title"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">
          Confirm delete of beneficiary
        </DialogTitle>
        <DialogContent>Are you sure you want to delete a beneficiary?</DialogContent>
        <DialogActions>
          {confirmDeleteActions.map((item, index) => (
            <div key={index}> {item}</div>
          ))}
        </DialogActions>
      </Dialog>
    )
  }

  editBeneficiaryDialog() {
    const open = this.state.openEditModal;
    return(
      <Dialog
      open={open}
      // open={!props.openAddPremiumDialog}
      fullWidth
      maxWidth='lg'
      onClose={this.closeEditBeneficiaryDialog.bind(this)}
      fullScreen
    >
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar style={{ background: PRIMARY_THEME_COLOR_SHADE_1 }}>
          <IconButton
            edge="start"
            color="inherit"
            onClick={this.closeEditBeneficiaryDialog.bind(this)}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Edit Beneficiary
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent>
         <AlertDialog
                      custom
                      show={!!this.props.showEditBeneficiaryProgressAlert}
                      size="sm"
                      style={{marginTop: '0', top: '30vh'}}
                      confirmBtnText="ok"
                      showCancel={false}
                      showConfirm={false}
                      cancelBtnText="cancel"
                      showTitle={false}
                      confirmBtnCssClass
                    >
                      <CircularProgress/>
                      <h2>Updating Beneficiary </h2>
                    </AlertDialog>
        
                    <AlertDialog
                      success
                      show={!!this.props.showEditBeneficiarySuccessAlert}
                      size="sm"
                      title="Beneficiary updated"
                      style={{marginTop: '0', top: '30vh'}}
                      onConfirm={() => {
                        this.props.resetEditBeneficiarySuccessAlert();
                      }}
                      confirmBtnText="ok"
                      showCancel={false}
                      showConfirm
                      cancelBtnText="cancel"
                      confirmBtnCssClass
                    ></AlertDialog>
        
                    <AlertDialog
                      show={!!this.props.showEditBeneficiaryErrorAlert}
                      danger
                      title="Error updating beneficiary "
                      onConfirm={() => this.props.resetEditBeneficiaryErrorAlert()}
                      confirmBtnText="ok"
                      confirmBtnCssClass
                      showCancel={false}
                      style={{marginTop: '0', top: '30vh'}}
                    >
                      {this.props.createBeneficiaryError
                        ? this.props.createBeneficiaryError.message
                        : ''}
                    </AlertDialog>
        <ValidatorForm onSubmit={this.updateBeneficiary.bind(this)} >

          <Grid container spacing={2}>
            <Grid item lg={3} md={3} xs={12}>
              <TextField
                fullWidth
                placeholder={this.state.labels.name}
                label={this.state.labels.name}
                name="name"
                variant="outlined"
                onChange={this.onFullNameChange.bind(this)}
                value={this.state.full_name}
              />
            </Grid>
            <Grid item lg={3} md={3} xs={12}>
              <TextField
                fullWidth
                placeholder={this.state.labels.firstName}
                label={this.state.labels.firstName}
                name="first_name"
                variant="outlined"
                onChange={this.onFirstNameChange.bind(this)}
                value={this.state.first_name}
              />
            </Grid>
            <Grid item lg={3} md={3} xs={12}>
              <TextValidator
                onChange={this.onLastNameChange.bind(this)}
                value={this.state.last_name}
                label='last name'
                name='last_name'
                fullWidth
                variant="outlined"
                type="text"
                placeholder='last_name'
                validators={['required']}
                errorMessages={['Please enter last name']}
              />
            </Grid>
            <Grid item lg={3} md={6} xs={12}>
              <DatePicker
                fullWidth
                variant="outlined"
                clearable
                label={this.state.labels.dateOfBirth}
                inputVariant="outlined"
                value={this.state.date_of_birth}
                onChange={this.onDateOfBirthChange.bind(this)}
                format="YYYY-MM-DD"
              />
            </Grid>
            <Grid item lg={3} md={6} xs={12}>
              {isSouthAfricanPartner() ? (
                <TextValidator
                  onChange={this.onNationalIdChange.bind(this)}
                  value={this.state.national_id}
                  label={this.state.labels.nationalId}
                  name="national_id"
                  fullWidth
                  variant="outlined"
                  placeholder={this.state.labels.nationalId}
                  validators={['required', 'isValidNationalId']}
                  errorMessages={[
                    'Please enter national id',
                    this.state.SAIdCheckError || 'Invalid national Id',
                  ]}
                />
              ) : (
                <TextField
                  fullWidth
                  placeholder={this.state.labels.nationalId}
                  label={this.state.labels.nationalId}
                  name="national_id"
                  variant="outlined"
                  onChange={this.onNationalIdChange.bind(this)}
                  value={this.state.national_id}
                />
              )}
            </Grid>

            <Grid item lg={3} md={6} xs={12}>
              <TextField
                fullWidth
                placeholder={this.state.labels.address}
                label={this.state.labels.address}
                name="address"
                variant="outlined"
                onChange={this.onAddressChange.bind(this)}
                value={this.state.address}
                multiline={true}
                rows={5}
              />
            </Grid>
            <Grid item lg={3} md={6} xs={12}>
              <TextField
                fullWidth
                placeholder={this.state.labels.email}
                label={this.state.labels.email}
                name="email"
                variant="outlined"
                onChange={this.onEmailChange.bind(this)}
                value={this.state.email}
                type="email"
              />
            </Grid>

            <Grid item lg={3} md={6} xs={12}>
              <TextValidator
                onChange={this.onMsiSdnChange.bind(this)}
                value={this.state.msisdn}
                label='msisdn'
                name='msisdn'
                fullWidth
                variant="outlined"
                type="number"
                placeholder='msisdn'
                validators={isSouthAfricanPartner() ? ['required'] : []}
                errorMessages={['Please enter msisdn']}
                maxLength={getLocalNumberLength()}
                onInput={(e) => {
                  e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, getLocalNumberLength())
                }}
                InputProps={{
                  startAdornment: (<InputAdornment position="start">
                    {getInternationalCallingCode()}
                  </InputAdornment>),
                }}
              />
            </Grid>


            <Grid item lg={3} md={6} xs={12}>
              <SelectValidator
                value={this.state.gender}
                label='gender'
                id="gender"
                name='gender'
                onChange={this.onGenderChange.bind(this)}
                className="form-control"
                type="text"
                variant="outlined"
                validators={['required']}
                errorMessages={['Please select gender']}
              >
                <MenuItem value="">{'Please select gender'}</MenuItem>
                {
                  ["Male", "Female"].map((type) => {
                    return <MenuItem value={type}>{type}</MenuItem>
                  })
                }
              </SelectValidator>
            </Grid>

            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Button variant="contained" type="submit" style={{ marginRight: '2%' }} onClick={this.updateDependant}> Update Benefiary </Button>
            </Grid>

          </Grid>
        </ValidatorForm>
      </DialogContent>
    </Dialog>
    )

  }


  render() {
    const beneficiary = this.props.beneficiaryData.beneficiary;
    const { labels } = this.state;
    let anchorElAction = this.state.anchorElAction
    console.log("customer beneficiary data", beneficiary)
    console.log("props beneficiary data", this.props)
    return (

      <div style={{ marginTop: "60px", marginBottom: "20px" }}>

        <ProductsHeader
          title="Beneficiary"
          onAddButtonClick={() => { this.setState({ openAddBeneficiaryDialog: true }) }}
          showAddBeneficiaryDialog={this.state.openAddBeneficiaryDialog}
          showAddButton={this.props.beneficiaryData.beneficiary === null || this.props.beneficiaryData.beneficiary ===''}
        />
        <AddBenefiary
          openAddBeneficiaryDialog={this.state.openAddBeneficiaryDialog}
          closeAddBeneficiaryDialog={this.closeAddBeneficiaryDialog.bind(this)}
          customerGuid={this.props.customerGuid}
          addBenefiary={this.addBenefiary.bind(this)}
          labels={labels}
          showAddBeneficiaryProgressAlert={this.props.beneficiaryData.createbeneficiaryLoader}
          showAddBeneficiarySuccessAlert={this.props.beneficiaryData.createbeneficiarySuccess}
          showAddBeneficiaryErrorAlert={!!this.props.beneficiaryData.createbeneficiaryError}
          resetAddBeneficiarySuccessAlert={()=>{this.props.dispatch(actions.resetAddCustomerBeneficiaryDetailsSuccess())}}
          resetAddBeneficiaryDetailsSuccessAlert={()=>{this.props.dispatch(actions.resetAddCustomerBeneficiaryDetailsSuccess())}}
          resetAddBeneficiaryErrorAlert={()=>{this.props.dispatch(actions.resetAddCustomerBeneficiaryDetailsFailed())}}
          resetAddBeneficiaryDetailsErrorAlert={()=>{this.props.dispatch(actions.resetAddCustomerBeneficiaryDetailsFailed())}}
        />

        <BeneficiaryTable
          beneficiary={beneficiary}
          customerGuid={this.props.customerGuid}
          labels={labels}
          setDeleteDialog={this.setDeleteDialog.bind(this)}
          setEditBeneficiary={this.setEditBeneficiary.bind(this)}
          displayEditButton={true}
          displayDeleteButton={true}
        />
        {this.props.children}
        {this.DisplayBeneficiaries(labels, beneficiary, anchorElAction)}
      </div>
    )
  }
  DisplayBeneficiaries(labels, beneficiary, anchorElAction) {
    return <Grid container spacing={2}>
      {this.editBeneficiaryDialog()}
      {this.deleteBeneficiaryDialog()}
    </Grid>;
  }
}
export default connect(state => ({
  globalData: state.global,
  beneficiaryData: state.customerBeneficiary,
}))(Beneficiary);
